import React from 'react'
import './FeedbackHeader.css';

export const FeedbackHeader = () => {
    return (
        <div className='feedback-header'>

            <p>Customers Feedback / Reports</p>

            <div className='filter-box'>
                <select>
                    <option>Filter</option>
                </select>
            </div>

        </div>
    )
}
